export const codeMap = {
  BACKGROUND_CHECK_BENEFITS: 'BG_BENEFITS',
  BACKGROUND_CHECK_EMPLOYMENT: 'BG_EMPLOYMENT',
  BACKGROUND_CHECK_CREDIT: 'BG_CREDIT',
  BACKGROUND_CHECK_HOUSING: 'BG_HOUSING',
  BACKGROUND_CHECK_INSURANCE: 'BG_INSURANCE',
  BACKGROUND_CHECK_PERSONAL: 'BG_PERSONAL',

  CONTACT_ENRICHMENT_CANDIDATE_CONTACT: 'EN_CANDIDATE_CONTACT',
  CONTACT_ENRICHMENT_POLITICAL_CAMPAIGN: 'EN_POLITICAL_CAMPAIGN',
  CONTACT_ENRICHMENT_SALES_PROSPECT_CONTACT: 'EN_SALES_PROSPECT_CONTACT',

  INVESTIGATION_CRIME: 'IN_CRIME',
  INVESTIGATION_FRAUD: 'IN_FRAUD',
  INVESTIGATION_JOURNALISTIC: 'IN_JOURNALISTIC',
  INVESTIGATION_PRIVATE_INVESTIGATOR: 'IN_PRIVATE_INVESTIGATOR',
  INVESTIGATION_DEBT_COLLECTION: 'IN_DEBT_COLLECTION',

  IDENTITY_VERIFICATION_FINANCIAL_FRAUD_PREVENTION: 'VE_FINANCIAL_FRAUD_PREVENTION',
  IDENTITY_VERIFICATION_AGE_COMPLINACE: 'VE_AGE_COMPLINACE',
  IDENTITY_VERIFICATION_ANTI_MONEY_LAUNDERING: 'VE_ANTI_MONEY_LAUNDERING',
  IDENTITY_VERIFICATION_GOVERNMENT: 'VE_GOVERNMENT',
  IDENTITY_VERIFICATION_EMPLOYMENT: 'VE_EMPLOYMENT',
  IDENTITY_VERIFICATION_HOUSING: 'VE_HOUSING',
  IDENTITY_VERIFICATION_BENEFITS: 'VE_BENEFITS',
  IDENTITY_VERIFICATION_INSURANCE: 'VE_INSURANCE',
  IDENTITY_VERIFICATION_CREDIT: 'VE_CREDIT',

  OTHER: 'OTHER',
  PERSONAL: 'PERSONAL',
};

export const displayUseCaseCodeMap = {
  BACKGROUND_CHECK_BENEFITS: 'Background Check - Benefits',
  BACKGROUND_CHECK_EMPLOYMENT: 'Background Check - Employment',
  BACKGROUND_CHECK_CREDIT: 'Background Check - Credit',
  BACKGROUND_CHECK_HOUSING: 'Background Check - Housing',
  BACKGROUND_CHECK_INSURANCE: 'Background Check - Insurance',
  BACKGROUND_CHECK_PERSONAL: 'Background Check - Personal',

  CONTACT_ENRICHMENT_CANDIDATE_CONTACT: 'Contact Enrichment - Candidate Contact Info',
  CONTACT_ENRICHMENT_POLITICAL_CAMPAIGN: 'Contact Enrichment - Political Campaign',
  CONTACT_ENRICHMENT_SALES_PROSPECT_CONTACT: 'Contact Enrichment - Sales Prospect Contact Info',

  INVESTIGATION_CRIME: 'Investigation - Crime',
  INVESTIGATION_FRAUD: 'Investigation - Fraud',
  INVESTIGATION_JOURNALISTIC: 'Investigation - Journalistic',
  INVESTIGATION_PRIVATE_INVESTIGATOR: 'Investigation - Private Investigator',
  INVESTIGATION_DEBT_COLLECTION: 'Investigation - Debt Collection',

  IDENTITY_VERIFICATION_FINANCIAL_FRAUD_PREVENTION: 'Identity Verification - Financial Fraud Prevention',
  IDENTITY_VERIFICATION_AGE_COMPLINACE: 'Identity Verification - Age Compliance',
  IDENTITY_VERIFICATION_ANTI_MONEY_LAUNDERING: 'Identity Verification - Anti Money Laundering',
  IDENTITY_VERIFICATION_GOVERNMENT: 'Identity Verification - Government',
  IDENTITY_VERIFICATION_EMPLOYMENT: 'Identity Verification - Employment',
  IDENTITY_VERIFICATION_HOUSING: 'Identity Verification - Housing',
  IDENTITY_VERIFICATION_BENEFITS: 'Identity Verification - Benefits',
  IDENTITY_VERIFICATION_INSURANCE: 'Identity Verification - Insurance',
  IDENTITY_VERIFICATION_CREDIT: 'Identity Verification - Credit',

  OTHER: 'Other',
  PERSONAL: 'Personal',
};

export default {
  MODULE_NAME: 'signup',
};
